import { FC } from 'react'
import cx from 'classnames'

import { FormikFormProps } from '../../form/FormikForm'
import FormFieldCheckboxGroup, {
  FormFieldCheckboxGroupProps,
} from '../../form/fields/FormFieldCheckboxGroup'
import FormFieldDropdownSelect, {
  FormFieldDropdownSelectProps,
} from '../../form/fields/FormFieldDropdownSelect'
import BoxedContainer from '../BoxedContainer'
import { ActionButtonVariant } from '../ActionButton/styled'

import * as SC from './styled'

export type ProductsFiltersFormValues = {
  groupPurchase?: Array<string>
  brand?: Array<number | string>
  categories?: Array<number | string>
}

export type ProductsFiltersProps = {
  className?: string
  isOpen: boolean
  texts?: {
    offersTitle?: string
    brandsTitle?: string
    categoriesTitle?: string
    submitButton: string
  }
  form: {
    formikForm: FormikFormProps<ProductsFiltersFormValues>
    fields: {
      offers?: FormFieldCheckboxGroupProps
      brands?: FormFieldDropdownSelectProps
      categories?: FormFieldDropdownSelectProps
    }
  }
}

const ProductsFilters: FC<ProductsFiltersProps> = ({
  className,
  form,
  texts,
  isOpen,
}) => {
  const { fields, formikForm } = form

  return (
    <SC.Filters className={cx('ProductsFilters', className)} $isOpen={isOpen}>
      <BoxedContainer>
        <SC.Form {...formikForm}>
          <SC.Fields>
            {fields.offers && (
              <SC.Block>
                <SC.BlockTitle>{texts?.offersTitle}</SC.BlockTitle>
                <FormFieldCheckboxGroup {...fields.offers} />
              </SC.Block>
            )}
            <SC.FieldsWrapper>
              {fields.brands && (
                <SC.Block>
                  <SC.BlockTitle>{texts?.brandsTitle}</SC.BlockTitle>
                  <FormFieldDropdownSelect {...fields.brands} />
                </SC.Block>
              )}
              {fields.categories && (
                <SC.Block>
                  <SC.BlockTitle>{texts?.categoriesTitle}</SC.BlockTitle>
                  <FormFieldDropdownSelect {...fields.categories} />
                </SC.Block>
              )}
              <SC.SubmitBlock>
                <SC.Submit
                  text={texts?.submitButton}
                  variant={ActionButtonVariant.tertiary}
                />
              </SC.SubmitBlock>
            </SC.FieldsWrapper>
          </SC.Fields>
        </SC.Form>
      </BoxedContainer>
    </SC.Filters>
  )
}

export default ProductsFilters
